import './AiLoadingIndicator.css';
export var container = '_1te6oqj8-3-8-0';
export var iconWrapper = '_1te6oqj7-3-8-0';
export var label = '_1te6oqj6-3-8-0';
export var labelAnimation = '_1te6oqj5-3-8-0';